var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg032Expand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10C3.44772 10 3 9.55228 3 9V6C3 4.34315 4.34315 3 6 3H9C9.55228 3 10 3.44772 10 4C10 4.55228 9.55228 5 9 5H6C5.44772 5 5 5.44772 5 6V9C5 9.55228 4.55228 10 4 10ZM18 3C19.6569 3 21 4.34315 21 6V9C21 9.55228 20.5523 10 20 10C19.4477 10 19 9.55228 19 9V6C19 5.44772 18.5523 5 18 5H15C14.4477 5 14 4.55228 14 4C14 3.44772 14.4477 3 15 3H18ZM3 18C3 19.6569 4.34315 21 6 21H9C9.55228 21 10 20.5523 10 20C10 19.4477 9.55228 19 9 19H6C5.44772 19 5 18.5523 5 18V15C5 14.4477 4.55228 14 4 14C3.44772 14 3 14.4477 3 15V18ZM19 15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15V18C21 19.6569 19.6569 21 18 21H15C14.4477 21 14 20.5523 14 20C14 19.4477 14.4477 19 15 19H18C18.5523 19 19 18.5523 19 18V15Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg032Expand);
export default __webpack_public_path__ + "static/media/032-expand.8ae97e04d1d1ab706c067f1f47ae64c5.svg";
export { ForwardRef as ReactComponent };